<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="stat-description"
    :class="
      cn(
        'flex min-w-0 items-center gap-1 truncate text-xs group-data-[align=center]/stat:flex-1 group-data-[align=center]/stat:justify-center group-data-[variant=joined]/stat-group:flex-1 group-data-[variant=joined]/stat-group:justify-center',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
